import LocationApi from "../apis/LocationApis";
import { setCookiesFromObject } from "GlobalUtils/Common";
import { detectLocationErrorMessage } from "SrcPath/constants";
import { getDetectLocationErrorMessage } from "SrcPath/utils/Location";

export const setGeoCoordinateToCookieByAreaId = areaId => {
  return new Promise((resolve, reject) => {
    LocationApi.fetchArea(areaId)
      .then(areaDetails => {
        const newCookies = {
          _CustLatitude: areaDetails.latitude,
          _CustLongitude: areaDetails.longitude,
        };
        setCookiesFromObject(newCookies);
        resolve();
      })
      .catch(error => {
        throw error;
      });
  });
};

export const getNearestAddress = (successCallback, errorCallback) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      function(position) {
        LocationApi.getAddress(
          position.coords.latitude,
          position.coords.longitude
        )
          .then(response => {
            successCallback(response);
          })
          .catch(() => {
            errorCallback(detectLocationErrorMessage.notFound);
          });
      },
      function(err) {
        const message = getDetectLocationErrorMessage(err);
        errorCallback(message);
      }
    );
  }
};
